import React from "react";
import GenesisMatcha from "../assets/genesis-matcha.jpeg";
import "../styles/About.css";
function About() {
  return (
    <div className="about">
      <div
        className="aboutTop"
        style={{ backgroundImage: `url(${GenesisMatcha})` }}
      ></div>
      <div className="aboutBottom">
        <h1>Genesis</h1>
        <h3>Our Genesis: From Nature to Elixir</h3>
        <p>Everything begins with nature. At <em>Verdant</em>, we believe taste is not just a sensation, but a memory. Our <em>Genesis</em> is the result of an obsession with pure raw materials, holistic wellness, and high aesthetics. We have created a space where matcha transcends habit to become an experience, where Eastern wisdom meets the pulse of the West. Here, the ritual of the bamboo whisk joins modern gastronomy to create unexpected harmonies. In our lab, ingredients like velvety salted caramel, Madagascan vanilla bean, and aromatic hibiscus are the notes composing the symphony of our <em>Elixirs</em>. Each cup is crafted to awaken the senses and ground the spirit. Whether you seek energy or a moment of absolute peace, <em>Verdant</em> is your urban sanctuary.</p>
      </div>
    </div>
  );
}

export default About;